// extracted by mini-css-extract-plugin
export var brand = "_ae-9";
export var compact = "_ae-6";
export var extraSmall = "_ae-7";
export var icon = "_ae-0";
export var large = "_ae-4";
export var light = "_ae-1";
export var medium = "_ae-5";
export var outline = "_ae-b";
export var primaryDark = "_ae-a";
export var primaryLight = "_ae-8";
export var primaryModern = "_ae-c";
export var success = "_ae-2";
export var successSolid = "_ae-3";